<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMicrophoneOff_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M15.75 12.625v-6.25A3.75 3.75 0 0 0 12 2.625a3.74 3.74 0 0 0-3.69 3.158l7.385 7.386.007-.049c.024-.163.048-.326.048-.495Zm2.5 0v-1.25a.625.625 0 0 0-1.25 0v1.25c0 .552-.111 1.074-.277 1.571l.973.973c.35-.779.554-1.636.554-2.544ZM4.805 4.045l15.512 15.514a.625.625 0 1 1-.883.883l-3.229-3.229a6.193 6.193 0 0 1-3.58 1.627v2.535a.625.625 0 0 1-1.25 0v-2.563c-3.149-.319-5.625-2.955-5.625-6.187v-1.25a.625.625 0 1 1 1.25.001v1.25c0 2.758 2.243 5 5 5 1.281 0 2.425-.511 3.308-1.308l-.873-.873a3.696 3.696 0 0 1-2.435.931 3.75 3.75 0 0 1-3.75-3.75V9.259l-4.329-4.33a.625.625 0 0 1 .884-.884Z"
        clip-rule="evenodd"
    />
</svg>
